module.exports = __webpack_public_path__ + "img/mt5-icon7.83aa305.png";